import { styled } from "@mui/system";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import Select from "@mui/material/Select";

export const CssTextField = styled(TextField)({
  ".MuiFormLabel-root": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
});

export const CssHeadTextField = styled(TextField)({
  ".MuiFormLabel-root": {
    color: "#ec0000c4",
    fontSize: 13,
  },
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
});

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${theme.breakpoints.up("md")}`]: {
    backgroundColor: "#003366",
    //color: theme.palette.common.white,
    padding: 6,
  },
  [`&.${theme.breakpoints.up("sm")}`]: {
    fontSize: 12,
    padding: 6,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const StyledAutoComplete = styled(Autocomplete)(({ theme }) => ({
  "& .MuiAutocomplete-input": {
    height: 10,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "3px",
  },
}));
export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    height: 10,
  },
  "& .MuiOutlinedInput-root": {
    margin: 0,
  },
}));

// export const CssSelectField = styled(Select)({
//   ".MuiSelect-select": {},
//   "& label.Mui-focused": {
//     color: "#ec0000c4",
//   },
//   "& .MuiInput-underline:after": {
//     borderBottomColor: "#ec0000c4",
//   },
//   "& .MuiOutlinedInput-root": {
//     "& fieldset": {
//       borderColor: "#ec0000c4",
//     },
//     "&:hover fieldset": {
//       borderColor: "#ec0000c4",
//     },
//     "&.Mui-focused fieldset": {
//       borderColor: "#ec0000c4",
//     },
//   },
//   "& div.MuiSelect-nativeInput": {
//     fontSize: 12,
//   },
// });
